export const errorInfoConfig = {
  dot: {
    empty: 'This field is required!',
    wrong: 'Not a valid DOT/ MC!',
  },
  mc: {
    empty: 'This field is required!',
    wrong: 'Not a valid DOT/ MC!',
  },
  email: {
    empty: 'This field is required!',
    wrong: 'Enter a valid email!',
  },
  text: {
    empty: 'This field is required!',
    wrong: '',
  },
  password: {
    confirm: 'Please enter the same password in both fields!',
    empty: 'Please enter a password!',
    wrong: 'Not less than four strings',
  },
  zip: {
    empty: 'This field is required!',
    wrong: 'Enter a valid zip code!',
  },
  phone: {
    empty: 'This field is required!',
    wrong: 'Enter a valid phone number!',
  },
  readTerms: {
    empty: 'You have to read terms first!',
  },
  signText: {
    empty: 'This field is required!',
    wrong: 'The signature name should be identical to your user name',
  },
  seatNum: {
    wrong: 'Users number is wrong!',
  },
  number: {
    empty: 'Value is requied!',
    wrong: 'Number only!',
    fuleWrong: 'Please enter a correct number.',
  },
  placeInput: {
    empty: 'You can\'t leave this empty.',
    wrong: 'Wrong city.',
  },
};



// WEBPACK FOOTER //
// ./src/misc/error-info.js